import { IndexTable, Text } from '@shopify/polaris';

const ProductStockTable = ({ product, hasTotal = true, canEdit = true, modifyStock, onModifyStock, deposit }) => {
  const headings = [{ title: '' }, ...product.variants.map((v) => ({ title: v.title })), { title: 'TOTAL' }] || [];

  if (product.deposits && product.deposits.length && !product.stock)
    product.stock = product.deposits.map((d) => d.stock.map((s) => ({ ...s, deposit: d }))).flat();
  else if (!product.deposits || !product.deposits.length)
    product.deposits = product.stock
      .map((s) => s.deposit)
      .filter((d, index, arr) => arr.findIndex((t) => t.id === d.id) === index);

  // Solo depósitos vivos: los que tienen alguna talla con cantidad. Un producto que ha
  // pasado por veinte tiendas arrastra veinte filas a cero que no dicen nada y tapan las
  // que sí. Se mira talla a talla y no el total de la fila, porque un depósito con +2 en
  // una talla y -2 en otra suma cero pero tiene movimiento que hay que ver.
  const rowMarkup = product.deposits
    .filter((d) => (deposit ? d.id === deposit.id : true))
    .map((d) => {
      const stocks = product.variants.map((v) => {
        const Sqty = product.stock.find((s) => v.barcode === s.barcode && s.deposit.id === d.id);
        return Sqty ? Sqty.qty : 0;
      });
      return { deposit: d, stocks, row: [d.name, ...stocks, stocks.reduce((acc, cur) => acc + cur, 0)] };
    })
    .filter(({ stocks }) => stocks.some((qty) => qty !== 0))
    .map(({ row, deposit }, index) => (
      <IndexTable.Row id={deposit.name} key={index} position={index} subdued selected={false}>
        {row.map((cell, i, arr) => (
          <IndexTable.Cell key={i}>
            <Text
              alignment={i ? 'center' : 'start'}
              variant="headingXs"
              fontWeight={!(i % row.length) || !((i + 1) % row.length) ? 'bold' : 'regular'}
            >
              {(i === 0 || i === arr.length - 1 || !canEdit || !modifyStock || deposit.id <= 0) && cell}
              {i === 0 && deposit.id > 0 && deposit.lastInventoryAt && (
                <span style={{ color: '#8c9196', fontSize: 11, fontWeight: 400, marginLeft: 6, whiteSpace: 'nowrap' }}>
                  {new Date(deposit.lastInventoryAt).toLocaleDateString('es-ES')}
                </span>
              )}
              {i > 0 && i < arr.length - 1 && canEdit && modifyStock && deposit.id > 0 && (
                <input
                  type="number"
                  value={cell}
                  onChange={(e) =>
                    onModifyStock({
                      qty: parseInt(e.target.value),
                      deposit,
                      barcode: product.variants[i - 1].barcode,
                    })
                  }
                  style={{ width: '50px', textAlign: 'center', backgroundColor: '#eaeaea' }}
                />
              )}
            </Text>
          </IndexTable.Cell>
        ))}
      </IndexTable.Row>
    ));

  rowMarkup.length > 1 &&
    hasTotal &&
    rowMarkup.push(
      <IndexTable.Row id={rowMarkup.length} key={rowMarkup.length} position={rowMarkup.length} disabled>
        <IndexTable.Cell>
          <Text alignment="start" fontWeight="bold">
            TOTAL
          </Text>
        </IndexTable.Cell>
        {product.variants.map((v, index) => (
          <IndexTable.Cell key={index}>
            <Text alignment="center" fontWeight="bold">
              {product.stock.filter((s) => s.barcode === v.barcode).reduce((acc, cur) => acc + cur.qty, 0)}
            </Text>
          </IndexTable.Cell>
        ))}
        <IndexTable.Cell>
          <Text alignment="center" fontWeight="bold">
            {product.stock.filter((s) => deposit ? s.deposit.id === deposit.id : true).reduce((acc, cur) => acc + cur.qty, 0)}
          </Text>
        </IndexTable.Cell>
      </IndexTable.Row>,
    );

  return (
    <IndexTable
      headings={headings}
      itemCount={rowMarkup.length}
      selectable={false}
      lastColumnSticky={true}
      emptyState={
        <div style={{ padding: '1.5rem 0', textAlign: 'center' }}>
          <Text variant="bodyMd" tone="subdued">
            Sin existencias en ningún depósito
          </Text>
        </div>
      }
    >
      {rowMarkup}
    </IndexTable>
  );
};

export default ProductStockTable;
